import { httpClient } from '@/services/http/httpClient'

type ResonseHorizontTags = {
  id: string
  name: string
  color: string
  textColor: string
}

type GetHorizontTagsParams = {
  portfolioId: string
  projectId: string
}
export const getHorizontTags = async ({
  portfolioId,
  projectId,
}: GetHorizontTagsParams) => {
  const { data } = await httpClient.get<ResonseHorizontTags[]>(
    `/projects/horizont-tags/${portfolioId}/${projectId}`,
  )

  return data
}
